import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NoticeFilter } from '@/components/notices/NoticeFilter';
import { NoticeCard } from '@/components/notices/NoticeCard';
import { NoticeDrawer } from '@/components/notices/NoticeDrawer';
import { useNotices, useMarkNoticeRead, type NoticeCategory, type NoticeItem } from '@/hooks/useNotices';
import { PullToRefresh } from '@/components/PullToRefresh';
import '@/styles/notices.css';

export function NoticesRoute() {
  const { t } = useTranslation();
  const [cat, setCat] = useState<NoticeCategory>('all');
  const { data: items = [], isLoading, refetch } = useNotices(cat);
  const [openNotice, setOpenNotice] = useState<NoticeItem | null>(null);
  const markRead = useMarkNoticeRead();

  function onOpen(item: NoticeItem) {
    setOpenNotice(item);
    if (item.unread) markRead.mutate(item.id);
  }

  return (
    <PullToRefresh onRefresh={async () => { await refetch(); }}>
      <div className="notices-page">
        <NoticeFilter current={cat} onChange={setCat} />

        {isLoading ? (
          <div className="notice-empty" aria-busy="true" />
        ) : items.length === 0 ? (
          <div className="notice-empty">
            <span className="material-symbols-outlined">campaign</span>
            {t('notices.empty')}
          </div>
        ) : (
          items.map((item) => <NoticeCard key={item.id} item={item} onOpen={() => onOpen(item)} />)
        )}

        <NoticeDrawer notice={openNotice} onClose={() => setOpenNotice(null)} />
      </div>
    </PullToRefresh>
  );
}
